import React, { Dispatch, SetStateAction } from 'react'
import { useModal } from '@ebay/nice-modal-react'
import { Button } from '@pepper/ui'
import { Modal } from 'antd'
import { Plus } from 'react-feather'

import { JOURNEYSTAGE } from './CreateOrganisationJourney'
import styles from './_.module.css'

type Props = {
  companyId: string
  moveToHome: () => void
  setJourneyState: Dispatch<SetStateAction<JOURNEYSTAGE>>
}

function SubmitOrgDetails({
  moveToHome,
  setJourneyState,
  companyId,
}: Props): JSX.Element {
  const serviceSelectionDrawer = useModal('service-selection-drawer')

  const createProject = () => {
    setJourneyState(JOURNEYSTAGE.CLOSED)
    serviceSelectionDrawer.show({ companyId })
  }

  const onCancel = () => {
    moveToHome()
  }

  const moveToAdminConsole = () => {
    window.location.href = `/${companyId}/admin-console/organisation`
  }
  return (
    <Modal
      title="Perfect"
      className={styles.modal}
      visible={true}
      footer={[
        <Button
          key="skip"
          type="text"
          className={styles.input_button_icon}
          onClick={onCancel}
        >
          Skip
        </Button>,
        <Button
          key="link"
          type="primary"
          className={styles.input_button_icon}
          onClick={createProject}
          icon={<Plus size="16px" />}
        >
          Create A Project
        </Button>,
      ]}
      onCancel={() => setJourneyState(JOURNEYSTAGE.CLOSED)}
    >
      <>
        Now we know you much better! You can always change your company
        information from the{' '}
        <Button
          type="link"
          onClick={moveToAdminConsole}
          className={styles.link_button}
        >
          Organisation Settings
        </Button>
        <br />
      </>
      Let’s move on and help you explore the platform
    </Modal>
  )
}

export default SubmitOrgDetails
